import AddAPhotoIcon from '@mui/icons-material/AddAPhoto'
import classNames from 'classnames'
import { ScreenEnum, useScreen } from 'feature/screenMode'
import { MouseEvent, RefObject } from 'react'

import style from './DragDropZone.module.scss'

type TDragDropZone = {
  dragActive: boolean
  uniqID: string
  helperTitle: string
  inputRef: RefObject<HTMLInputElement>
}

// зона для добавления файлов
export const DragDropZone = ({
  dragActive,
  uniqID,
  helperTitle,
  inputRef,
}: TDragDropZone) => {
  const screen = useScreen()

  const onButtonClick = (e: MouseEvent<HTMLElement>) => {
    e.preventDefault()
    e.stopPropagation()
    if (inputRef.current) {
      inputRef.current.click()
    }
  }

  return (
    <label
      className={classNames(
        style.fileUploadLabel,
        dragActive && style.dragActive,
      )}
      id={`label-file-upload-${uniqID}`}
      htmlFor={`input-file-upload-${uniqID}`}
    >
      <div className={style.labelText}>
        <AddAPhotoIcon className={style.fileUploadLogo} />
        {(screen === ScreenEnum.tablet || screen === ScreenEnum.mobile) && (
          <button
            type='button'
            className={style.fileUploadButton}
            onClick={onButtonClick}
            data-testid='drag-drop-upload-btn'
          >
            {helperTitle}
          </button>
        )}

        {screen === ScreenEnum.desktop && (
          <div className={style.uploadFile}>
            <span>Перетащите или</span>
            <span className={style.fileUploadButton}>выберите файл</span>
          </div>
        )}
      </div>
    </label>
  )
}
